import { getTopFilterColorClass } from '../../layouts/helpers/topFilterConfig';

const HIT_FILTER_PILL_BASE =
  'inline-flex items-center gap-1 max-w-full rounded-full px-2.5 py-1.5 text-xs font-medium border-2 no-underline hover:brightness-[0.97] dark:hover:brightness-110 transition-all';

/**
 * Category-coloured pill for hit cards / metadata (matches top filter bar).
 */
export function getHitFilterPillClasses(attribute: string, isExcluded = false): string {
  return `${HIT_FILTER_PILL_BASE} ${getTopFilterColorClass(attribute, isExcluded)}`;
}
